import { ApiSimpleTenant } from "@incendium/api";
import SamlTenantDialog from "features/sso/components/SamlTenantDialog";
import SamlTenantsList from "features/sso/components/SamlTenantsList";
import { useLayoutContext } from "Providers/LayoutProvider";
import { useLayoutEffect, useState } from "react";

function SamlTenantsPage() {
  const { setPageTitle } = useLayoutContext();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [tenantToEdit, setTenantToEdit] = useState<ApiSimpleTenant | null>(
    null,
  );

  useLayoutEffect(() => {
    setPageTitle("SSO tenants");
    return () => setPageTitle("");
  }, [setPageTitle]);

  const openCreate = () => {
    setTenantToEdit(null);
    setDialogOpen(true);
  };

  const openEdit = (tenant: ApiSimpleTenant) => {
    setTenantToEdit(tenant);
    setDialogOpen(true);
  };

  const closeDialog = () => {
    setDialogOpen(false);
    setTenantToEdit(null);
  };

  return (
    <>
      <SamlTenantsList onAddClick={openCreate} onEditClick={openEdit} />
      <SamlTenantDialog
        open={dialogOpen}
        tenantToEdit={tenantToEdit}
        onClose={closeDialog}
      />
    </>
  );
}

export default SamlTenantsPage;
